import { Country } from '../models/common/places';

function isDefinedISO2CountryCode(key: unknown): key is keyof typeof Country {
  return typeof key === 'string' && key in Country;
}

export const toISO3CountryCode = (countryCode: string) => {
  const countryCodeCapitalized = countryCode.toUpperCase();
  if (isDefinedISO2CountryCode(countryCodeCapitalized)) {
    return Country[countryCodeCapitalized];
  }
  return undefined;
};
